export default __webpack_public_path__ + "static/media/servicio-paseo.058231aa.jpg";